/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import './loader.css'

const Loader = () => {
  return <div className="custom-loader" ></div>;
};

export default Loader;
